import { render, staticRenderFns } from "./shortcodeFeature.vue?vue&type=template&id=5e19c114&"
import script from "./shortcodeFeature.vue?vue&type=script&lang=js&"
export * from "./shortcodeFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports